import { render, staticRenderFns } from "./news1.vue?vue&type=template&id=8adc4d34&scoped=true&"
import script from "./news1.vue?vue&type=script&lang=js&"
export * from "./news1.vue?vue&type=script&lang=js&"
import style0 from "./news1.vue?vue&type=style&index=0&id=8adc4d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adc4d34",
  null
  
)

export default component.exports